// Hero carousel slides for the homepage.
// Three slides that walk a visitor through the Seternity story:
//   1. Who we are  →  2. What we do  →  3. Who we do it for
//
// Swap `image` for any wide (landscape) photo in /public/images.
// Recommended source size: ~2400x1350, compressed to under 400KB.

export const heroSlides = [
  {
    id: "partner",
    eyebrow: "Trusted Outsourcing & Financial Services Partner",
    title: "Your Offshore Finance,",
    titleAccent: "Research & Analytics Partner",
    description:
      "Seternity Solutions operates as an extension of your team — combining domain expertise with structured, technology-enabled workflows to reduce cost and increase output.",
    image: "/images/hero-slide-1.jpg",
    imageAlt:
      "Seternity Solutions finance and research professionals collaborating",
    primaryCta: { label: "Explore Who We Are", href: "/about-us" },
    secondaryCta: { label: "Talk to Our Team", href: "/contact" },
  },
  {
    id: "capabilities",
    eyebrow: "What We Do",
    title: "Six Capabilities.",
    titleAccent: "One Accountable Partner.",
    description:
      "Accounting and bookkeeping, capital markets research, investment and transaction advisory, market research, data analytics, and business process support — delivered under a single engagement.",
    image: "/images/hero-slide-4.jpg",
    imageAlt: "Financial analysis and reporting workflows in progress",
    primaryCta: { label: "See All Capabilities", scrollTo: "services" },
    secondaryCta: { label: "Request a Proposal", href: "/contact" },
  },
  {
    id: "clients",
    eyebrow: "Who We Work With",
    title: "Institution-Ready Support for",
    titleAccent: "Buy-Side Firms, Banks & Global Businesses",
    description:
      "500+ research projects delivered across 40+ sectors — supporting buy-side firms, investment banks, asset and wealth managers, and growth-stage businesses worldwide.",
    image: "/images/hero-slide-3.jpg",
    imageAlt: "Global client teams supported by Seternity Solutions",
    primaryCta: { label: "See Who We Serve", href: "/about-us#industries" },
    secondaryCta: { label: "Contact Us", href: "/contact" },
  },
];

export default heroSlides;
